﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function startpageSearch(context) {
  const searchField = context.querySelector('#startpage-search-input');
  const searchFieldBg = context.querySelector('.startpage__hero__search__bg');
  const searchButton = context.querySelector('.startpage__hero__search__button');
  const suggestionsList = document.querySelector('#startpage-suggestions-list');
  const currentLanguage = document.querySelector('html').getAttribute('lang');
  const currentCountry = document.querySelector('html').getAttribute('country');

  let noResultsTimeout;
  let searchComplete = false;
  let currentSuggestions = [];
  let previousSearch = '';

  const searchFieldHiddenAddress = context.querySelector('#startpage-search-address');
  const searchFieldHiddenName = context.querySelector('#startpage-search-name');
  const searchFieldHiddenLocationLat = context.querySelector('#startpage-search-location-lat');
  const searchFieldHiddenLocationLng = context.querySelector('#startpage-search-location-lng');

  async function initAutocomplete() {
    const { AutocompleteSessionToken, AutocompleteSuggestion } = await google.maps.importLibrary('places');
    const sessionToken = new AutocompleteSessionToken();

    const keyUpHandler = async (e) => {
      if (previousSearch === searchField.value || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter') return;

      const request = {
        input: searchField.value,
        language: currentLanguage,
        region: currentCountry,
        includedRegionCodes: [currentCountry],
        sessionToken
      };

      const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

      previousSearch = searchField.value;
      const iconMarker = document.createElement('span');
      iconMarker.classList.add('pac-icon');
      iconMarker.classList.add('pac-icon-marker');
      currentSuggestions = suggestions;

      suggestionsList.innerHTML = '';
      suggestionsList.style.display = 'block';

      if (suggestions.length === 0 && searchField.value && searchField.value.length > 2 && !searchComplete) {
        const form = document.querySelector('[data-controller=startpage-search]');
        const noResultsMessage = form.dataset.noresultsMessage;
        const container = document.querySelector('.pac-container');
        container.style.display = 'block';
        container.setAttribute('data-noresults-message', noResultsMessage);
        return;
      }

      suggestionsList.classList.add('markfirst');

      suggestions.forEach((suggestion, i) => {
        if (i > 5) return;
        const placePrediction = suggestion.placePrediction;
        const listItem = document.createElement('li');
        listItem.classList.add('pac-item');
        listItem.appendChild(iconMarker.cloneNode(true));

        highlightText(placePrediction.text.toString(), listItem);

        listItem.setAttribute('data-place-id', placePrediction.placeId);
        listItem.setAttribute('tabindex', '0');
        suggestionsList.appendChild(listItem);

        listItem.addEventListener('click', listItemsClickHandler);
      });
    }

    const debouncedKeyUpHandler = debounce((e)=> keyUpHandler(e), 500)

    const listItemsClickHandler = async (e) => {
      suggestionsList.classList.remove('markfirst');
      const listItems = document.querySelectorAll('.pac-item');
      listItems.forEach(item => item.classList.remove('pac-item-selected'));
      e.target.classList.add('pac-item-selected');

      const clickedID = e.target.getAttribute('data-place-id');

      if (!clickedID) return;
      const clickedSuggestion = currentSuggestions.find(suggestion => suggestion.placePrediction.placeId === clickedID);
      const name = clickedSuggestion.placePrediction.text.toString();
      const place = clickedSuggestion.placePrediction.toPlace();
      searchField.value = name;

      await place.fetchFields({ fields: ['formattedAddress', 'location'] });

      if (!place.formattedAddress) return;

      suggestionsList.style.display = 'none';
      searchFieldHiddenName.value = name.split(', ')[0];
      searchFieldHiddenAddress.value = place.formattedAddress;
      searchFieldHiddenLocationLat.value = place.location.lat().toFixed(5);
      searchFieldHiddenLocationLng.value = place.location.lng().toFixed(5);
      searchButton.click();
    }

    const highlightText = (suggestionText, listItem) => {
      const strong = document.createElement('strong');
      let matchingString = '';
      const searchValueArray = searchField.value.split('');
      const compareText = suggestionText ? suggestionText.toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o') : '';

      searchValueArray.forEach((character, i) => {
        if (!compareText.toLowerCase().includes(matchingString)) return;
        matchingString += character.toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o');
      });

      const beforeMatchingString = suggestionText.substring(0, compareText.indexOf(matchingString));
      const afterMatchingString = suggestionText.substring(compareText.indexOf(matchingString) + matchingString.length, suggestionText.length);

      if (beforeMatchingString) listItem.appendChild(document.createTextNode(beforeMatchingString));
      strong.appendChild(document.createTextNode(suggestionText.substring(compareText.indexOf(matchingString), compareText.indexOf(matchingString) + matchingString.length)));
      listItem.appendChild(strong);
      listItem.appendChild(document.createTextNode(afterMatchingString));
    }

    const searchItemsHandler = (e) => {
      //Make it possible to use arrow keys to navigate the results
      if (!searchField.value) {
        suggestionsList.style.display = 'none';
        suggestionsList.innerHTML = '';
        previousSearch = '';
        return;
      }

      const searchSuggestions = document.querySelectorAll('.pac-item');

      if (document.querySelector('.pac-item-selected')) {
        document.querySelector('.pac-container').classList.remove('markfirst');
      } else {
        document.querySelector('.pac-container').classList.add('markfirst');
      }

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (searchSuggestions.length === 0) return;
        let selected = document.querySelector('.pac-item-selected');
        if (!selected) {
          searchSuggestions[0].classList.add('pac-item-selected');
        }
        let nextSelected;
        if (selected && e.key === 'ArrowDown') {
          nextSelected = selected.nextElementSibling;
        } else if (selected) {
          nextSelected = selected.previousElementSibling;
        }
        if (selected && nextSelected) {
          selected.classList.remove('pac-item-selected');
          nextSelected.classList.add('pac-item-selected');
        } 
        if (selected && !nextSelected && selected === searchSuggestions[searchSuggestions.length - 1]) {
          selected.classList.remove('pac-item-selected');
          searchSuggestions[0].classList.add('pac-item-selected');
        }
        const selectedID = document.querySelector('.pac-item-selected').getAttribute('data-place-id');
        const selectedSuggestion = currentSuggestions.find(suggestion => suggestion.placePrediction.placeId === selectedID);
        const name = selectedSuggestion.placePrediction.text.toString();
        searchField.value = name;
        return;
      }

      debouncedKeyUpHandler(e)
    }

    searchField.addEventListener('keyup', searchItemsHandler);

    searchField.addEventListener('focus', () => {
      const position = searchFieldBg.getBoundingClientRect();
      const styling = window.innerWidth < 768 ? `width:${searchFieldBg.offsetWidth}px;left:${position.left}px;top:${position.bottom - 10}px;` :
        `width:${searchFieldBg.offsetWidth - 40}px;left:${position.left + 20}px;top:${position.bottom - 10}px;`;
      suggestionsList.style.cssText = styling;
      if (document.querySelectorAll('.pac-item').length > 0) suggestionsList.style.display = 'block'
    });
    searchField.addEventListener('blur', (e) => {
      const list = document.querySelector('#results');
      if (!e.relatedTarget || (list && !list.contains(e.relatedTarget))) suggestionsList.style.display = 'none'
    });

    context.addEventListener('submit', (e) => {
      searchComplete = true;
      clearTimeout(noResultsTimeout);
      if (searchFieldHiddenAddress.value.length === 0) {
        e.preventDefault();
        const selected = document.querySelector('.pac-item-selected') || document.querySelector('.pac-item');
        if (selected) selected.click();
        return;
      }

      searchButton.focus();
      context.setAttribute('aria-busy', 'true');
    });
  }

  const debounce = (func, wait, immediate) => {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  function init() {
    initAutocomplete()
  }

  return {
    init
  };
}

controller.add('startpage-search', startpageSearch);